import { type TProduct as TApiProduct } from '@core/api'

import { type TProduct } from '@core/models'

import { convertPrice } from './convertPrice'

export const convertProduct = (apiProduct: TApiProduct): TProduct => {
    const {
        id,
        code,
        is_trial,
        is_paid_trial,
        trial_duration_days,
        trial_price,
        old_price,
        final_price,
        duration_count,
        duration,
        suffix,
        name,
        plan,
        currency,
        local_country,
        local_price,
        local_trial_price,
    } = apiProduct

    return {
        id,
        code,
        isTrial: Boolean(is_trial),
        isPaidTrial: Boolean(is_paid_trial),
        trialDurationDays: trial_duration_days,
        trialPrice: trial_price,
        oldPrice: old_price,
        finalPrice: final_price,
        durationCount: duration_count,
        duration,
        suffix,
        name,
        plan,
        currency,
        localCountry: local_country,
        localPrice: local_price ? convertPrice(local_price) : undefined,
        localTrialPrice: local_trial_price ? convertPrice(local_trial_price) : undefined,
    }
}
